// Token listing management: fixed lists from the v1 contract
// (TOKEN_LISTINGS_API.md). network_id is the shared internal chain id used by
// BiorLabs_backend and the app (database_init_data.dart), not an EVM chain id.

export const CHAINS = [
  { network_id: 27, name: "Robinhood Chain", evm: true },
  { network_id: 1,  name: "Ethereum",        evm: true },
  { network_id: 14, name: "Base",            evm: true },
  { network_id: 4,  name: "Arbitrum",        evm: true },
  { network_id: 6,  name: "Solana",          evm: false },
  { network_id: 2,  name: "BSC",             evm: true },
  { network_id: 5,  name: "Avalanche",       evm: true },
  { network_id: 16, name: "Bitcoin Cash",    evm: false },
  { network_id: 3,  name: "Polygon",         evm: true },
  { network_id: 25, name: "Optimism",        evm: true },
  { network_id: 24, name: "NEAR",            evm: false },
  { network_id: 0,  name: "Bitcoin",         evm: false },
];

export const CHAIN_BY_ID = Object.fromEntries(CHAINS.map((c) => [String(c.network_id), c]));

export const chainName = (id) => {
  const c = CHAIN_BY_ID[String(id)];
  return c ? c.name : id === null || id === undefined ? "-" : `Chain ${id}`;
};

export const CATEGORIES = [
  { slug: "layer-1", name: "Layer 1" },
  { slug: "layer-2", name: "Layer 2" },
  { slug: "dex", name: "DEX" },
  { slug: "defi", name: "DeFi" },
  { slug: "privacy", name: "Privacy" },
  { slug: "meme", name: "Meme" },
  { slug: "ai", name: "AI" },
  { slug: "gaming", name: "Gaming" },
  { slug: "stablecoin", name: "Stablecoin" },
  { slug: "launchpad", name: "Launchpad" },
  { slug: "infrastructure", name: "Infrastructure" },
  { slug: "community", name: "Community" },
  { slug: "tokenized-stocks", name: "Tokenized stocks" },
];

export const CATEGORY_NAME = Object.fromEntries(CATEGORIES.map((c) => [c.slug, c.name]));

export const STATUSES = [
  { value: "active",   label: "Active",   color: "#00CD52" },
  { value: "delisted", label: "Delisted", color: "#ff6e6e" },
  { value: "draft",    label: "Draft",    color: "#9CA3AF" },
];

export const STATUS_META = Object.fromEntries(STATUSES.map((s) => [s.value, s]));

// Where the app draws the Sponsored tag, named after the app's current screens
// (one design since 2026-10-26; ADMIN_PANEL_MAP.md). Only real placements are
// listed. The API still accepts the old keys and reads stored ones as the new
// keys; PLACEMENT_ALIASES maps a listing saved before the rename.
export const PLACEMENTS = [
  { value: "market_tokens", label: "Market › Tokens", hint: "The Tokens list on the Market tab" },
  { value: "home_holdings", label: "Home holdings + token page", hint: "The account rows on Home, the Asset page and the token's own page" },
];

export const PLACEMENT_ALIASES = { market: "market_tokens", holdings: "home_holdings" };

export const PLACEMENT_LABEL = Object.fromEntries(PLACEMENTS.map((p) => [p.value, p.label]));

// The current key for a placement, or null for one the app no longer has.
export const canonicalPlacement = (p) => {
  if (PLACEMENTS.some((x) => x.value === p)) return p;
  return Object.prototype.hasOwnProperty.call(PLACEMENT_ALIASES, p) ? PLACEMENT_ALIASES[p] : null;
};

// Computed sponsorship states shown in the table (see sponsorshipState()).
export const SPONSOR_STATES = {
  none:      { label: "None",             color: "#6b7280" },
  pending:   { label: "Pending approval", color: "#f3af4c" },
  scheduled: { label: "Scheduled",        color: "#7B7CFF" },
  active:    { label: "Active",           color: "#00CD52" },
  ended:     { label: "Ended",            color: "#9CA3AF" },
};

export const PAGE_SIZE = 25;

export const MAX_SPONSOR_DAYS = 30;
export const MAX_LOGO_BYTES = 512 * 1024;
export const LOGO_TYPES = ["image/png", "image/jpeg", "image/webp"];
export const NOTES_MAX = 5000;

export const PERM_VIEW = "token_listings.view";
export const PERM_MANAGE = "token_listings.manage";
export const PERM_SPONSOR = "token_listings.sponsor";
